import { Directive, HostBinding, HostListener, Input, inject, output } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

export interface FileHandle {
  file: File;
  url: SafeUrl;
}

@Directive({
  selector: '[panDragDropFiles]',
  standalone: false,
})
export class DragDropFilesDirective {
  readonly files = output<FileHandle[]>();
  readonly dragActive = output<boolean>();

  @Input() public applyDefaultDragStyle = true;

  private active = false;
  private sanitizer = inject(DomSanitizer);

  @HostBinding('style.background') public get background(): string | null {
    if (!this.applyDefaultDragStyle) return null;
    return this.active ? '#999' : '#eee';
  }

  @HostListener('dragover', ['$event']) public onDragOver(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.setActive(true);
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.setActive(false);
  }

  @HostListener('drop', ['$event']) public onDrop(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.setActive(false);

    const files: FileHandle[] = [];
    for (let i = 0; i < evt.dataTransfer.files.length; i++) {
      const file = evt.dataTransfer.files[i];
      const url = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(file));
      files.push({ file, url });
    }
    if (files.length > 0) {
      this.files.emit(files);
    }
  }

  private setActive(active: boolean): void {
    if (this.active === active) return;
    this.active = active;
    this.dragActive.emit(active);
  }
}
